import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  root: {
    position: "relative",
  },
  ul: {
    position: "relative",
    display: "flex",
    ...shorthands.overflow("hidden"),
    ...shorthands.gap("24px"),

    "@media (min-width: 767px) and (max-width: 953px)": {
      paddingRight: "43px",
      marginLeft: "46px",
      marginRight: "46px",
    },

    "@media (min-width: 480px) and (max-width: 767px)": {
      paddingRight: "26px",
      marginLeft: "46px",
      marginRight: "46px",
    },

    "@media (max-width: 480px)": {
      paddingRight: "26px",
      marginLeft: "46px",
      marginRight: "46px",
    },
  },
});
